<ng-container *ngIf="!isProduction">
    <lazy-component moduleUri="@lazy-modules-module/devLog/dev-log.module#DevLogModule"></lazy-component>
</ng-container>

<bma-main class="vn-bma"></bma-main>
